import React from 'react';
import WebViewerPDFTron from '../WebViewerPDFTron';


function DashboardCard07() {
  return (
    <div className="col-span-full xl:col-span-12 bg-white shadow-lg rounded-sm border border-gray-200">
      <WebViewerPDFTron />
    </div>
  );
}

export default DashboardCard07;
